export class JobDescriptionReq{
    jobDescription:string
}